import { render, staticRenderFns } from "./factoryInfo.vue?vue&type=template&id=171eb87e&scoped=true&"
import script from "./factoryInfo.vue?vue&type=script&lang=js&"
export * from "./factoryInfo.vue?vue&type=script&lang=js&"
import style0 from "./factoryInfo.vue?vue&type=style&index=0&id=171eb87e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171eb87e",
  null
  
)

export default component.exports